<template>
  <div class="plan-modal">
    <div class="container">
      <div class="plan-content">
        <div class="plan-wrapper">
          <div class="print-turn">
            <h1 class="print-turn-title">مرکز درمانی مام</h1>
            <!-- <div class="print-turn-number">
              <div class="count">140</div>
              <div>پذیرش</div>
            </div> -->
            <div class="print-turn-number">
              <div>دکتر {{doctorInfo }} - {{ unitId }}</div>
            </div>
            <table class="table table-bordered print-turn-table">
              <tr>
                <td>نام</td>
                <td>{{ userName }}</td>
              </tr>
              <!-- <tr>
                <td>کد ملی</td>
                <td>{{ nationalCode }}</td>
              </tr> -->
              <tr>
                <td>زمان نوبت</td>
                <td>
                  {{ reserveDate }} - {{ reserveFromTime }}
                </td>
              </tr>
              <tr>
                <td>دکتر</td>
               <td> {{ doctorInfo }}</td>                
              </tr>
              <!-- <tr>
                <td>تخصص</td>
                <td>{{ speciality }}</td>
              </tr> -->
            </table>
            <div class="print-turn-footer" v-if="!openPrint">
              <b-button variant="success" @click="print" class="p-0 mx-1">
                پرینت
              </b-button>
              <b-button
                variant="danger"
                class="p-0 mx-1"
                @click="$emit('close')"
              >
                بستن
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dateFormat from "@/mixins/dateFormat";
import { BButton } from "bootstrap-vue";
export default {
  name: "PrintTurn",
  props: [
    "reserveDate",
    "reserveFromTime",
    "userName",
    "doctorName",
    "nationalCode",
    "doctorInfoProps",
    "unitId",
    "turnUserId",
    "doctorInfo",
  ],
  components: {
    BButton,
  },
  computed:{

  },
  data() {
    return {
      speciality: "",
      openPrint: false,
      unitName:'',
    };
  },
  mixins: [dateFormat],
  mounted() {
    // this.$store
    //   .dispatch("medicalSpecialties/getActiveMedicalSpecialty")
    //   .then((res) => {
    //     this.speciality = res.find(
    //       (item) => item._id
    //     ).title;
    //   });
    // this.$store
    //   .dispatch("units/getUnits", {
    //     page: 1,
    //     limit: 20,
    //   })
    //   .then((res) => {
    //     this.unitId = res.find((item) => item._id === this.unitId).title;
    //       });

  },
  methods: {
    print() {
      this.openPrint = true;
      setTimeout(() => {
        this.$emit("close");
        window.print();
      }, 50);
    },
  },
};
</script>

<style scoped>
.table-responsive {
  height: 455px;
  overflow-y: auto;
  background: white;
}
</style>
